import React, { useState } from "react";

import clsx from "clsx";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import EditIcon from "@material-ui/icons/Edit";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import TodayIcon from "@material-ui/icons/Today";
import formatMoney from "../../../utils/formatMoney";
import SubCategory from "./SubCategoryCard";
import useStyles from "../../../assets/cardStyles";
import ScheduleContentCard from "./ScheduleContentCard";
import { Link } from "react-router-dom";
import { deleteFromDB } from "../../../utils/menuFormHandler";

export default function MenuCard(props) {
	const classes = useStyles();
	const [isExpanded, setIsExpanded] = useState(false);
	const [isDisplayingDate, setIsDisplayingDate] = useState(false);
	const [isDeleting, setIsDeleting] = useState(false);
	const { data, id, db } = props;

	const handleExpandClick = () => {
		setIsExpanded(!isExpanded);
	};

	const handleDisplayDate = () => {
		setIsDisplayingDate(!isDisplayingDate);
	};

	const handleDelete = () => {
		if (window.confirm(`Desea eliminar ${data.name}`)) {
			setIsDeleting(true);
			deleteFromDB({ db, id, data });
		}
	};

	return (
		<Card className={classes.root}>
			{Boolean(data?.imgUrl) && <CardMedia className={classes.media} image={data.imgUrl} title={data.name} />}
			<CardHeader title={data.name} subheader={`${data.category}`} />
			<CardContent className={classes.content}>
				<Typography variant="body2" color="textPrimary" component="p">
					Precio inicial: {formatMoney(data.price)}
				</Typography>
				<Typography variant="body2" color="textPrimary" component="p">
					{data.description} <br />
				</Typography>
			</CardContent>
			<CardActions disableSpacing>
				<IconButton aria-label="borrar" onClick={handleDelete} disabled={isDeleting}>
					<DeleteForeverIcon />
				</IconButton>

				<Link to={`add?${id}`}>
					<IconButton aria-label="Edit">
						<EditIcon />
					</IconButton>
				</Link>
				<IconButton
					className={clsx(classes.expandDate, {
						[classes.expandDateOpen]: isDisplayingDate,
					})}
					onClick={handleDisplayDate}
					aria-label="mostrar fechas"
				>
					<TodayIcon />
				</IconButton>
				{!!data?.subCategories?.length > 0 && (
					<IconButton
						className={clsx(classes.expand, {
							[classes.expandOpen]: isExpanded,
						})}
						onClick={handleExpandClick}
						aria-expanded={isExpanded}
						aria-label="show more"
					>
						<ExpandMoreIcon />
					</IconButton>
				)}
			</CardActions>
			<Collapse in={isDisplayingDate} timeout="auto" unmountOnExit>
				<ScheduleContentCard
					data={{
						scheduleOpens: data?.scheduleOpens,
						scheduleCloses: data?.scheduleCloses,
						availableDays: data?.availableDays,
					}}
				/>
			</Collapse>
			{!!data?.subCategories?.length > 0 && (
				<Collapse in={isExpanded} timeout="auto" unmountOnExit>
					<CardContent className={classes.smallPadding}>
						{data?.subCategories?.map((subcategory, index) => (
							<SubCategory key={`subcategory${index}`} data={subcategory} />
						))}
					</CardContent>
				</Collapse>
			)}
		</Card>
	);
}
